
import { Directive, HostBinding } from '@angular/core';

@Directive({
  // tslint:disable-next-line
  selector: "optgroup"
})
// tslint:disable-next-line: directive-class-suffix
export class OptGroup {
  @HostBinding('class') inputClass = 'select-option';
}
